import React, { useState } from 'react';
import { Star } from 'lucide-react';

/** Accessible 5-star rating input. Brand cyan/primary accent. */
export const StarRating = ({
  value = 0,
  onChange,
  readOnly = false,
  size = 24,
  testId = 'star-rating',
}) => {
  const [hover, setHover] = useState(0);
  const stars = [1, 2, 3, 4, 5];
  const display = hover || value;

  return (
    <div
      className="flex items-center gap-1"
      role={readOnly ? 'img' : 'radiogroup'}
      aria-label={readOnly ? `${value} out of 5` : 'Rate from 1 to 5'}
      data-testid={testId}
    >
      {stars.map((n) => {
        const isActive = n <= display;
        return (
          <button
            key={n}
            type="button"
            disabled={readOnly}
            aria-checked={!readOnly && value === n}
            role={readOnly ? undefined : 'radio'}
            onClick={() => !readOnly && onChange?.(n)}
            onMouseEnter={() => !readOnly && setHover(n)}
            onMouseLeave={() => !readOnly && setHover(0)}
            className={
              'transition-colors ' +
              (readOnly
                ? 'cursor-default'
                : 'cursor-pointer hover:scale-110 transform transition-transform')
            }
            data-testid={`${testId}-star-${n}`}
            aria-label={`${n} ${n === 1 ? 'star' : 'stars'}`}
          >
            <Star
              size={size}
              strokeWidth={1.5}
              fill={isActive ? '#2B7CFF' : 'none'}
              color={isActive ? '#2B7CFF' : '#9CA3AF'}
            />
          </button>
        );
      })}
    </div>
  );
};

export default StarRating;
